import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './manutencaoItemForm';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, initForm, salvar, excluir, getLista, 
	getListaVeiculo, getListaManutencaoArea, getListaUnidade
} from './manutencaoItemActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

class ManutencaoItem extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaVeiculo();
		this.props.getListaManutencaoArea();
		this.props.getListaUnidade();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaVeiculo();
			this.props.getListaManutencaoArea();
			this.props.getListaUnidade();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		// let listaExportacao = [];
		// this.props.lista.forEach(item => {
		// 	(item.itens || []).forEach(manutencaoItemItem => {
		// 		listaExportacao.push({
		// 			...item,
		// 			id: `${item.id}-${manutencaoItemItem.id}`,					
		// 			datahora_programacao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_programacao),
		// 			datahora_carga: item.datahora_carga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_carga) : null,
		// 			datahora_previsao_chegada: item.datahora_previsao_chegada ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_chegada) : null,
		// 			datahora_descarga: item.datahora_descarga ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_descarga) : null,
		// 			nome_produto: manutencaoItemItem.nome_produto,
		// 			quantidade: FormatUtils.formatarValorTela(manutencaoItemItem.quantidade, 2)
		// 		});
		// 	});
		// });
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_veiculo: (this.state.ids_veiculos || []).length == 1 ? this.state.ids_veiculos[0] : null
									});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					{/* <input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} /> */}
					<Row>
						<Select
							options={this.props.listaVeiculo}
							label='Veículo'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaVeiculo.filter(item => (this.state.ids_veiculos || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_veiculos: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaManutencaoArea}
							label='Manutenção'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaManutencaoArea.filter(item => (this.state.ids_areas || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_areas: (values || []).map(item => item.value) });
							}} />

						<Select
							options={this.props.listaUnidade}
							label='Unidade'
							cols='12 6 3 3'
							placeholder='Selecione'
							multiple
							value={this.props.listaUnidade.filter(item => (this.state.ids_unidades || []).includes(item.id)).map(item => ({ value: item.id, label: item.valor }))}
							onChange={values => {
								this.setState({ ids_unidades: (values || []).map(item => item.value) });
							}} />
					</Row>
					<Table responsive>
						<THead>
							<Tr>
								<Th width={10} alignCenter>Data</Th>
								<Th width={100} alignCenter>Veículo</Th>
								<Th width={100} alignCenter>Tipo do Veículo</Th>
								<Th width={100} alignCenter>Unidade</Th>
								<Th width={100} alignCenter>Manutenção</Th>
								<Th width={100} alignCenter>Descrição</Th>
								<Th width={100} alignCenter>Dias em Aberto</Th>
								<Th width={100}></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => {
								if (this.state.pesquisar
									&& !(`
										${DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}
										${item.placa_veiculo}
										${item.nome_tipo}
										${item.nome_unidade}
										${item.nome_manutencao_area}
										${item.descricao}
										${item.dias_aberto == 0 ? 'Hoje' : (item.dias_aberto == 1 ? 'ontem' : `${item.dias_aberto} dias`)}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								
								if ((this.state.ids_veiculos || []).length && !(this.state.ids_veiculos || []).includes(item.id_veiculo)) {
									return false;
								}
								if ((this.state.ids_areas || []).length && !(this.state.ids_areas || []).includes(item.id_manutencao_area)) {
									return false;
								}
								if ((this.state.ids_unidades || []).length && !(this.state.ids_unidades || []).includes(item.id_unidade)) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)}</Td>
									<Td alignCenter>{item.placa_veiculo}</Td>
									<Td alignCenter>{item.nome_tipo}</Td>
									<Td alignCenter>{item.nome_unidade}</Td>
									<Td alignCenter>{item.nome_manutencao_area}</Td>
									<Td alignCenter>{item.descricao}</Td>
									<Td alignCenter>{item.dias_aberto == 0 ? 'Hoje' : (item.dias_aberto == 1 ? 'ontem' : `${item.dias_aberto} dias`)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.manutencaoItem,
	modoTela: state.manutencaoItem.modoTela,
	lista: state.manutencaoItem.lista,
    listaVeiculo: state.manutencaoItem.listaVeiculo,
	listaManutencaoArea: state.manutencaoItem.listaManutencaoArea,
    listaUnidade: state.manutencaoItem.listaUnidade
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista,
	getListaVeiculo, getListaManutencaoArea, getListaUnidade
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ManutencaoItem);
